// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3Gd4g","label":"LabeledBox_label__3qd7O"};